import { z } from "zod";

import { defaultItem, defaultUrl, transformerMdContentParam, itemSchema, urlSchema } from "../shared";
import { createId } from "@paralleldrive/cuid2";

// Schema
export const referenceSchema = itemSchema.extend({
  name: z.string().min(1),
  description: z.string(),
  summary: transformerMdContentParam,
  url: urlSchema,
});

export const minimalReferenceSchema = referenceSchema.omit({
  id: true,
  visible: true,
});

// Type
export type Reference = z.infer<typeof referenceSchema>;
export type MinimalReference = z.infer<typeof minimalReferenceSchema>;

// Defaults
export const defaultReference: Reference = {
  ...defaultItem,
  name: "",
  description: "",
  summary: "",
  url: defaultUrl,
};

export const deminimalizeReference = (reference: MinimalReference): Reference => {
  return {
    ...defaultReference,
    ...reference,
    id: createId(),
  };
};
